const indexItems = [
  { id: 1, title: '2024 年度高分电影榜', count: '50 部', tag: '年度盘点' },
  { id: 2, title: '韩剧热播TOP20', count: '20 部', tag: '热门' },
  { id: 3, title: '国产剧高分精选', count: '35 部', tag: '国剧' },
  { id: 4, title: '漫威宇宙观影顺序', count: '30 部', tag: '系列' },
  { id: 5, title: '日剧治愈系合集', count: '25 部', tag: '日剧' },
  { id: 6, title: '奥斯卡获奖影片全集', count: '80+ 部', tag: '经典' },
  { id: 7, title: 'Netflix 原创佳作', count: '40 部', tag: '流媒体' },
  { id: 8, title: '纪录片精选推荐', count: '60 部', tag: '纪实' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 text-center mb-2">专题合集</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按主题整理的观影指南，快速找到你想看的</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div key={item.id} className="bg-background-100/70 rounded-lg p-4 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="flex items-start justify-between mb-2">
                <h3 className="text-sm font-medium text-foreground-800">{item.title}</h3>
                <span className="px-1.5 py-0.5 text-xs rounded bg-accent-100 text-accent-700 whitespace-nowrap ml-1">{item.tag}</span>
              </div>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-film-line"></i>
                <span>{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}